import { TextStyled, theme } from '../component-library';
import { UnorderedList } from '../component-library';
import { useTestContext } from '../context/testContext';
import { usePostMessage } from '../context/messageContext';
import { confirmNavigation } from '../helpers/functions';
import { useResultData } from '../helpers/useResultData';
import { useBreakpoints } from '../helpers/useBreakpoints';
import { useEndSession } from '../helpers/useEndSession';
import styled from '@emotion/styled';

const NavLink = styled.li`
  padding: ${({ lg }) => (lg ? '0.125rem' : '0')};
  ${({ isActive, secondaryColor }) => isActive && `border-right: 5px solid ${secondaryColor}`};
  &:hover {
    span {
      color: ${({ secondaryColor }) => secondaryColor};
    }
  }
`;

const Navigation = ({ activeTab, setActiveTab }) => {
  const { lg } = useBreakpoints();
  const { clearAllResults } = useResultData();
  const postMessage = usePostMessage();
  const endSession = useEndSession();
  const {
    testData: { testInProgress },
  } = useTestContext();

  const NavigationTabComponent = ({ title, onItemClicked, isActive, id }) => {
    return (
      <NavLink
        secondaryColor={theme.colors.secondary}
        isActive={isActive}
        onClick={() => (id === 'end-session' ? endSession() : onItemClicked())}
        lg={lg}
      >
        <TextStyled
          as='span'
          color={id === 'end-session' ? '#d70909' : theme.colors.primary}
          ml={lg ? '30px' : '15px'}
          style={{ fontSize: lg ? '1rem' : '0.825rem' }}
        >
          {title}
        </TextStyled>
      </NavLink>
    );
  };

  const navigationOptions = [
    { id: 'calibration-selection', title: 'Calibration Selection' },
    { id: 'set-distance', title: 'Set Distance' },
    { id: 'test', title: 'Examinations' },
    { id: 'results', title: 'Completed Examinations' },
    { id: 'consultationView', title: 'Consultation View' },
    { id: 'end-session', title: 'End Session' },
  ];

  const handleNavigation = (newTab) => {
    const legacyNavRoutes = ['consultationView'];
    if (legacyNavRoutes.includes(newTab)) postMessage({ type: newTab });
    if (newTab === 'test') postMessage({ type: 'testNavigationReset' });
    if (newTab === 'consultationView') postMessage({ type: 'endOfTest' });
    if (newTab === 'calibration-selection') {
      postMessage({ type: 'testCalibrationReset' });
    }
    return setActiveTab(newTab);
  };

  return (
    <UnorderedList>
      {navigationOptions.map(({ id, title }) => (
        <NavigationTabComponent
          key={title}
          title={title}
          onItemClicked={() => {
            if (testInProgress)
              return confirmNavigation().then(() => {
                clearAllResults();
                return handleNavigation(id);
              });
            return handleNavigation(id);
          }}
          isActive={activeTab === id}
          id={id}
        />
      ))}
    </UnorderedList>
  );
};

export default Navigation;
